import React, { useRef } from "react";
import { useAction } from "@/components/toolkit/InputProvider";
import "./s.dialog.css";


export function Dialog(props: {
    title: string;
    onClose: () => void;
    children: React.ReactNode;
}) {
    const overlayRef = useRef<HTMLDivElement>(null);

    useAction('dialog', 'close', props.onClose, [props.onClose]);

    return (
        <div
            className="dialog__overlay"
            data-input-component="dialog"
            data-input-focus="move"
            ref={overlayRef}
            onMouseDown={e => { if (e.target === overlayRef.current) props.onClose(); }}
        >
            <div className="dialog__box">
                <div className="dialog__header">
                    <span className="dialog__title">{props.title}</span>
                    <button className="dialog__close" onClick={props.onClose}>✕</button>
                </div>
                <div className="dialog__body">
                    {props.children}
                </div>
            </div>
        </div>
    );
}
